import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { PlacementTestService } from '../services/placement-test';

export function useGetPlacementTestResult() {
  const { data, error, isFetching, isLoading, isError } = useQuery({
    queryKey: ['getPlacementTestResult'],
    queryFn: PlacementTestService.getPlacementTestResult,
    retry: (failureCount, error: AxiosError) => {
      if (error.response?.status === 422) {
        return false;
      }
      return failureCount < 3;
    },
  });

  return {
    placementTestResult: data,
    error,
    isFetching,
    isLoading,
    isError,
  };
}
